import { RefObject, useEffect, useState } from 'react';

import Box from '@mui/material/Box';

import useAdminTokenUsageFilters from '@features/admin-token-usage/hooks/useAdminTokenUsageFilters.tsx';
import MainTable from '@components/MainTable';
import { useTanStackTable } from '@hooks/useTanStackTable';
import { createAdminTokenUsageTotalTableColumns } from '@features/admin-token-usage/containers/AdminTokenUsageTotalTable/columns.tsx';
import { AdminTokenUsageTotalTableRow } from '@features/admin-token-usage/types';
import AdminTokenUsageTotalTableToolbar from '@features/admin-token-usage/containers/AdminTokenUsageTotalTable/toolbar.tsx';

function AdminTokenUsageTotalTable() {
  const { totalTableData } = useAdminTokenUsageFilters();
  const [tableRef, setTableRef] = useState<RefObject<HTMLTableElement> | null>(
    null
  );

  const { table, setColumns, setData } =
    useTanStackTable<AdminTokenUsageTotalTableRow>({
      tableData: [],
      columnConfig: [],
      // Do not apply the global default sorting (which sorts by column id "id")
      // This table should preserve the row order we provide (e.g., Total should be last).
      initialSorting: [],
      options: {
        getRowId: (row) => row.name,
      },
    });

  useEffect(() => {
    if (!totalTableData) return;
    setColumns(createAdminTokenUsageTotalTableColumns(totalTableData));
    setData(totalTableData.rows);
  }, [totalTableData]);

  return (
    <Box display="flex" flexDirection="column" gap={2} marginTop={3}>
      <AdminTokenUsageTotalTableToolbar table={table} tableRef={tableRef} />
      <MainTable table={table} onTableRefReady={(ref) => setTableRef(ref)} />
    </Box>
  );
}

export default AdminTokenUsageTotalTable;
